import { render, staticRenderFns } from "./DataStatistics.vue?vue&type=template&id=90a15c48&scoped=true&"
import script from "./DataStatistics.vue?vue&type=script&lang=js&"
export * from "./DataStatistics.vue?vue&type=script&lang=js&"
import style0 from "styles/views/orderAdmin/dataStatistics.css?vue&type=style&index=0&id=90a15c48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a15c48",
  null
  
)

export default component.exports